import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';

export enum CREATION_TYPE {
    COPY_FROM_OWN = 'COPY_FROM_OWN',
    COPY_AS_RNO = 'COPIED_AS_WOM',
}

export interface CopyLessonModalStore {
    shouldShowModal: boolean;
    sourceId: number | null;
    newName: string | null;
    copyLessonLoadingStatus: LOADING_STATUSES;
    creationType: CREATION_TYPE;
}

export type CopyLessonResponse = Array<{ course_id: number; clesson_id: number }>;
